export function initGTM(gtmId) {
    if (!gtmId) return;

    // Create/prime the dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': Date.now(),
        event: 'gtm.js',
    });

    // Inject the GTM loader script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
        gtmId
    )}`;
    document.head.appendChild(script);

    // (Optional) Add the <noscript> iframe for non-JS users
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(
        gtmId
    )}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
}